var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v(" Logout ")]),(!_vm.isAuthenticated && !_vm.profile)?_c('div',[_vm._v(" You have been logged out. ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }